import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/system';

const StyledFormControlLabel = styled(FormControlLabel)({
  '&.MuiFormControlLabel-root': {
    marginTop: '17px',
    marginLeft: '5px',
  },
});

function MuiCheckbox({ label, value, onChange = () => {}, ...props }) {
  return (
    <StyledFormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={(event) => onChange(event.target.checked)}
          {...props}
        />
      }
      label={label}
    />
  );
}

export default MuiCheckbox;